import { useState } from "react";
import { qrImage } from "@/lib/api";

export const Badge = ({ registration: r, event }) => {
  const [qrFailed, setQrFailed] = useState(false);
  const fullName = `${r.first_name} ${r.last_name}`.trim();
  const table = (r.table || "").trim();
  return (
    <div id="printable-badge-area" data-testid="printable-badge">
      <div className="bg-white text-slate-900 border-2 border-slate-300 rounded-2xl shadow-2xl p-6 w-full max-w-[420px] relative overflow-hidden print:shadow-none print:border-black">
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-16 h-2 rounded-full bg-slate-200 border border-slate-300" />
        <p className="text-[10px] uppercase tracking-[0.25em] font-semibold text-slate-500 mt-4">{event.name}</p>
        <p className="text-[10px] text-slate-500">
          {event.date} · {event.venue}
        </p>
        {r.salutation && (
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mt-4" data-testid="badge-salutation">
            {r.salutation}
          </p>
        )}
        <h3
          className={`font-black uppercase leading-none tracking-tight ${
            r.salutation ? "mt-1" : "mt-4"
          } ${fullName.length > 26 ? "text-xl" : fullName.length > 18 ? "text-2xl" : "text-3xl"}`}
          data-testid="badge-name"
        >
          {fullName}
        </h3>
        {(r.job_title || r.company) && (
          <p className="text-xs text-slate-600 mt-2">
            {r.job_title}
            {r.job_title && r.company ? " · " : ""}
            {r.company}
          </p>
        )}
        <div className="flex items-end justify-between gap-4 mt-6">
          <div className="min-w-0 flex-1">
            {table ? (
              <>
                <p className="text-[9px] uppercase tracking-[0.2em] text-slate-400">Table</p>
                <p
                  className={`font-black uppercase leading-none text-slate-900 break-words ${
                    table.length > 10 ? "text-xl" : "text-3xl"
                  }`}
                  data-testid="badge-table"
                >
                  {table}
                </p>
              </>
            ) : (
              <>
                <p className="text-[9px] uppercase tracking-[0.2em] text-slate-400">Reference</p>
                <p className="font-mono2 text-sm font-bold text-slate-700">{r.registration_code}</p>
              </>
            )}
          </div>
          {qrFailed ? (
            <div
              className="w-20 h-20 border-2 border-dashed border-slate-300 rounded-md grid place-items-center text-center px-1"
              data-testid="badge-qr-unavailable"
            >
              <span className="text-[8px] uppercase tracking-wider text-slate-400 leading-tight">
                Pass not
                <br />
                released yet
              </span>
            </div>
          ) : (
            <img
              src={qrImage(r.qr_token)}
              alt="badge qr"
              className="w-20 h-20 shrink-0"
              data-testid="badge-qr-image"
              onError={() => setQrFailed(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
